import styled from 'styled-components';

export const ZillowNavbarSubSectionLinkAnchorContainer = styled.li`
    line-height: 40px;
`;
